import DatePicker from './DatePicker.vue';

export default DatePicker;
